/** Seedbarer Zufall (mulberry32). Alle Spielentscheidungen laufen über rnd(), damit Partien aus Seed + Eingaben reproduzierbar sind (Replays, Multiplayer mit geteiltem Seed). */
let state = 0x9e3779b9;
let draws = 0;
export function seedRng(seed: number) { state = (seed >>> 0) || 1; draws = 0; }
export function rngState() { return { state, draws }; }
export function restoreRng(s: { state: number; draws: number }) { state = s.state; draws = s.draws; }
export function rnd(): number {
  draws++;
  state = (state + 0x6d2b79f5) >>> 0;
  let t = state;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
export const choice = (a: any[]): any => a[Math.floor(rnd() * a.length)];
export const ri = (a: number, b: number) => a + Math.floor(rnd() * (b - a + 1));
export function shuffle<T>(a: T[]): T[] { a = a.slice(); for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; }
